(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobile_menu_div = document.querySelector('.menu-drawer__navigation-container');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.announcement_bar_setting = $(this).hasClass('keep_announcement_on_scroll');
      this.headerBounds = {};
      this.menu_drawer = document.querySelector('#menu-drawer');
      this.menu_close_btn = document.querySelector('.menu_close_svg');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        if (this.announcement_bar_setting) {
          //console.log('on...');
          // this.menu_close_btn.classList.remove('adjust_close_btn');
        } else {
          //console.log('off...');
          this.header.classList.add('shopify-section-header-sticky');
        }
       
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      //console.log("scrollTop: " + scrollTop + " | currentScrollTop: " + this.currentScrollTop + " | this.headerBounds.bottom: " + this.headerBounds.bottom);
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if ((scrollTop + 60) > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.menu_drawer.classList.add('adjust_mobile_menu');
        this.mobile_menu_div.classList.add('adjust_mobile_menu_div');
        if (this.headerIsAlwaysSticky) {
            if (this.announcement_bar_setting) {

            } else {
              this.menu_close_btn.classList.add('adjust_close_btn');
            }
        };
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.menu_drawer.classList.add('adjust_mobile_menu');
        this.mobile_menu_div.classList.add('adjust_mobile_menu_div');
        if (this.headerIsAlwaysSticky) {
            if (this.announcement_bar_setting) {

            } else {
              this.menu_close_btn.classList.add('adjust_close_btn');
            }
        };
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.menu_drawer.classList.add('adjust_mobile_menu');
        this.mobile_menu_div.classList.add('adjust_mobile_menu_div');
        if (this.headerIsAlwaysSticky) {
            if (this.announcement_bar_setting) {

            } else {
              this.menu_close_btn.classList.add('adjust_close_btn');
            }
        };
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.menu_drawer.classList.remove('adjust_mobile_menu');
        this.mobile_menu_div.classList.remove('adjust_mobile_menu_div');
        if (this.headerIsAlwaysSticky) {
            if (this.announcement_bar_setting) {

            } else {
              this.menu_close_btn.classList.remove('adjust_close_btn');
            }
        };
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
